export type ShotOriginArea = (typeof ShotOriginArea)[keyof typeof ShotOriginArea];

export const ShotOriginArea = {
  UNKNOWN: 'UNKNOWN',
  RIGHT_CORNER: 'RIGHT_CORNER',
  LEFT_CORNER: 'LEFT_CORNER',
  RIGHT_SHORT_CORNER: 'RIGHT_SHORT_CORNER',
  LEFT_SHORT_CORNER: 'LEFT_SHORT_CORNER',
  RIGHT_BLOCK: 'RIGHT_BLOCK',
  LEFT_BLOCK: 'LEFT_BLOCK',
  RIGHT_RIM: 'RIGHT_RIM',
  LEFT_RIM: 'LEFT_RIM',
  RIGHT_ELBOW: 'RIGHT_ELBOW',
  LEFT_ELBOW: 'LEFT_ELBOW',
  RIGHT_HIGH_PAINT: 'RIGHT_HIGH_PAINT',
  LEFT_HIGH_PAINT: 'LEFT_HIGH_PAINT',
  RIGHT_WING: 'RIGHT_WING',
  LEFT_WING: 'LEFT_WING',
  FREETHROW: 'FREETHROW',
  SHORT_KEY: 'SHORT_KEY',
  TOP_KEY: 'TOP_KEY',
} as const;

export function isShotOriginArea(arg: unknown): arg is ShotOriginArea {
  return Object.values(ShotOriginArea).includes(arg as ShotOriginArea);
}

export function isShotOriginAreaArray(arg: unknown): arg is ShotOriginArea[] {
  return Array.isArray(arg) && arg.every(isShotOriginArea);
}
